import { type Static, Type } from '@sinclair/typebox';
import { PodcastDTOSchema } from '../dto/podcast.dto.js';

export const SearchQuerystringSchema = Type.Object({ search: Type.String() });
export type SearchQuerystring = Static<typeof SearchQuerystringSchema>;

export const SearchReplySchema = Type.Array(PodcastDTOSchema);
export type SearchReply = Static<typeof SearchReplySchema>;
